import { ImportOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import TFilterButton from 'components/rest/Filter/FilterButton';
import { TFilterRequest } from 'components/rest/Filter/FilterContent';
import { TFilterItem } from 'components/rest/Filter/FilterRow';
import ShowButton from 'components/rest/Filter/ShowButton';
import { FilterWrapper } from 'components/rest/Filter/styles';
import SearchInput from 'layout/PrivateLayout/SearchInput';
import React, { ReactNode } from 'react';
import { IRestColumnProps } from '../Table/TableColumn';
import { useTranslation } from 'react-i18next';
import ExportExcelButton from '../FilterV2/ExportExcelButton';
import { DynamicObjectType } from 'types/commons';
import ImportButton from '../ImportActions/ImportButton';
import ExportButton from '../ExportActions/ExportButton';
import { LabelValuePairsType } from 'core/types/common';

export type TRestFilterProps = {
  placeholder?: string;
  filterContent?: React.ReactElement;
  filters?: TFilterItem[];
  columns?: IRestColumnProps[];
  filterData?: TFilterRequest[];
  hasExport?: boolean;
  hasImport?: boolean;
  hasShow?: boolean;
  showColumns?: string[];
  onChangeSearchQ?: (q: string, fieldSearch?: string) => void;
  defaultValueQ?: string;
  initFieldSearch?: string;
  extraActionFilters?: React.ReactElement | React.ReactElement[];
  exportExcelQuery?: string;
  model?: string;
  excelName?: string;
  isExportWithFilter?: boolean;
  filter?: DynamicObjectType;
  hasExportV2?: boolean;
  hasImportV2?: boolean;
  openModalImport?: () => void;
  openModalExport?: () => void;
  hasToolTipExportButton?: boolean;
  toolTipContent?: ReactNode | (() => ReactNode);
  dataFieldSearch?: LabelValuePairsType;
  customExport?: (
    exportExcelQuery?: string,
    excelName?: string,
    callback?: () => void,
  ) => void;
};

export default function RestFilter({
  columns,
  showColumns,
  hasShow = true,
  hasImport = true,
  hasExport = true,
  placeholder,
  filterData,
  filters,
  filterContent,
  onChangeSearchQ,
  defaultValueQ = '',
  initFieldSearch,
  extraActionFilters,
  exportExcelQuery,
  model,
  excelName,
  isExportWithFilter,
  filter,
  hasExportV2,
  hasImportV2,
  openModalImport,
  openModalExport,
  hasToolTipExportButton,
  toolTipContent,
  dataFieldSearch,
  customExport,
}: TRestFilterProps) {
  const { t } = useTranslation();

  const onPressEnter = (value, valueFieldSearch) => {
    onChangeSearchQ?.(value, valueFieldSearch);
  };

  return (
    <FilterWrapper className="d-flex wrap">
      <div className="flex-1">
        <SearchInput
          defaultValue={defaultValueQ}
          onPressEnter={onPressEnter}
          defaultValueSelectSearch={initFieldSearch}
          placeholder={placeholder}
          dataFieldSearch={dataFieldSearch}
        />
      </div>
      <Space wrap className="ml-2.5">
        {extraActionFilters}
        {/* {React.Children.map(extraActionFilters, (child) => child)} */}
        {!!filters?.length && (
          <TFilterButton
            filterData={filterData}
            filters={filters}
            content={filterContent}
          />
        )}
        {!hasImportV2 && hasImport && (
          <Button size="large" className="text-sm" icon={<ImportOutlined />}>
            {t('button.import')}
          </Button>
        )}
        {/* {hasExport && (
          <Button size="large" className="text-sm" icon={<ExportOutlined />}>
            {t('button.export')}
          </Button>
        )} */}
        {hasExport && exportExcelQuery && (
          <ExportExcelButton
            resource={model}
            excelName={excelName}
            isExportWithFilter={isExportWithFilter}
            resourceFilter={filter}
            exportExcelQuery={exportExcelQuery}
            customExport={customExport}
          />
        )}
        {hasImportV2 && <ImportButton onClick={openModalImport} />}
        {hasExportV2 && (
          <>
            {hasToolTipExportButton ? (
              <Tooltip
                title={toolTipContent}
                trigger={['click']}
                overlayClassName="tooltip-export"
              >
                <ExportButton onClick={() => {}} />
              </Tooltip>
            ) : (
              <ExportButton onClick={openModalExport} />
            )}
          </>
        )}

        {hasShow && <ShowButton showColumns={showColumns} columns={columns} />}
      </Space>
    </FilterWrapper>
  );
}
